(ns app.front.ui.chat-input
  "Rounded search-bar style chat input with an icon send button.
   Manages its own message atom; calls :on-submit with the message string
   and resets the field afterwards."
  (:require [app.front.ui :as ui]
            [app.front.ui.icon-button :as ui-ib]
            [app.front.util :as futil]
            [clojure.string :as str]
            [core.front.icons :as i]
            [reagent.core :as r]))

(defn chat-input
  "Props:
   - :id               – input element id
   - :placeholder      – input placeholder text
   - :label-text       – visually hidden label (for accessibility)
   - :input-class      – optional override for input padding/style
                         (default: `p-12 pl-6 py-6 ...`)
   - :send-description – aria description for the send button
   - :on-submit        – fn called with the trimmed message string;
                         the field is reset automatically after calling it"
  [{:keys [id placeholder label-text input-class send-description on-submit]}]
  (r/with-let [*message (r/atom "")]
    (let [submit! (fn []
                    (when-not (str/blank? @*message)
                      (on-submit @*message)
                      (reset! *message "")))]
      [:div.flex.items-center.relative.w-full
       [ui/text-input
        {:id          id
         :input-class (or input-class
                          "p-12 pl-6 py-6 border border-solid border-gray-300 rounded-full bg-white")
         :placeholder placeholder
         :label-text  label-text
         :hide-label  true
         :value       @*message
         :on-change   #(reset! *message (futil/tval %))
         :on-key-up   #(when (futil/enter-press? %)
                         (submit!)
                         (-> % .-currentTarget .blur))}]
       [:div.absolute {:style {:right "6px"}}
        [ui-ib/icon-button
         {:icon        i/arrow-right
          :fill        "white"
          :class       "bg-ui-violet-100 rounded-full flex items-center justify-center w-10 h-10 hover:bg-ui-violet-130"
          :description send-description
          :on-click    submit!}]]])))
